export function EnterEventDirective() {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope, elem, attrs) {
        elem.bind('keydown keypress', function (event) {
            if (event.which == 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.enterEvent);
                });
                event.preventDefault();
            }
        })
    }
}


// WEBPACK FOOTER //
// ./client/components/util/enter-event.js